/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EodMelcoEodModelsPartnerListItem
 */
export interface EodMelcoEodModelsPartnerListItem {
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsPartnerListItem
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsPartnerListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsPartnerListItem
     */
    url?: string | null;
}

export function EodMelcoEodModelsPartnerListItemFromJSON(json: any): EodMelcoEodModelsPartnerListItem {
    return EodMelcoEodModelsPartnerListItemFromJSONTyped(json, false);
}

export function EodMelcoEodModelsPartnerListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoEodModelsPartnerListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function EodMelcoEodModelsPartnerListItemToJSON(value?: EodMelcoEodModelsPartnerListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'url': value.url,
    };
}


